import { useCallback, useRef } from 'react'

export default function useAudioEngineReloadedDevicesCache() {
    const reloadedTimeRef = useRef<Record<string, Date>>({})

    const shouldReloadDeviceOnUnresponsive = useCallback((deviceId: string) => {
        if (reloadedTimeRef.current[deviceId]) {
            const dt = new Date().getTime() - reloadedTimeRef.current[deviceId].getTime()
            // if has not been reloaded in the last 30 seconds, reload it.
            const doReload = dt > 1000 * 30
            return doReload
        }
        return true
    }, [])

    const saveReloadUnresponsiveDeviceInfo = useCallback((deviceId: string) => {
        reloadedTimeRef.current[deviceId] = new Date()
    }, [])

    return {
        shouldReloadDeviceOnUnresponsive,
        saveReloadUnresponsiveDeviceInfo,
    }
}
